export const getIsNetflixLogin = () =>
  new URLSearchParams(window.location.search).get("loginType") === "netflix";
